export default "__VITE_ASSET__7e56032d__"